import * as React from 'react'
import { FC } from 'react'
import { useLocation } from 'react-router-dom'

import { getEnabledLinks, linkActive, Tier1Link } from '../../../helpers/navStructure'
import Tier2NavItem from './Tier2NavItem'
import { ConstrainedFullWidth } from '../../../components/layout'
import { getRedHome } from '../../../helpers/urls'
import { regionalizePath } from '../../../dataImplementation/viewingRegionWeb'

type Tier1ExactLink = Tier1Link & { exactMatch?: boolean }

const Tier2NavBar: FC = () => {
  const location = useLocation()
  const onHomePage = location.pathname === '/'
  const onErrorPage = location.pathname === '/_error'
  let links: Tier1Link[]

  if (onHomePage || onErrorPage) {
    links = getEnabledLinks().filter(({ label }) => label !== 'Home')
  } else {
    const activeSecondNav = getEnabledLinks().find(({ href, children }) =>
      linkActive(href.startsWith('/virgin-red') ? regionalizePath(href.replace('/virgin-red', '')) : href, children, location.pathname)
    )
    links = activeSecondNav ? (activeSecondNav.children as Tier1Link[]) : []
  }

  if (links.length === 0) {
    return null
  }

  const links2: Tier1ExactLink[] = [...links]
  const isPathVirginRed = location.pathname.includes('/virgin-red')

  if (isPathVirginRed) {
    links2.unshift({
      backgroundImageUrl: '',
      href: getRedHome().to,
      label: 'Home',
      children: [],
      exactMatch: true,
    })
  }

  return (
    <>
      <style jsx>{`
        .tier2-bar-nav {
          margin: 0;
          padding: 0;
          height: 64px;
          display: flex;
          list-style-type: none;
          justify-content: space-evenly;
        }
      `}</style>
      <ConstrainedFullWidth>
        <nav aria-label={isPathVirginRed ? 'Virgin Red navigation' : 'Virgin navigation'}>
          <ul className="tier2-bar-nav" data-testid="tier2-bar-nav">
            {links2.map((l) => (
              <Tier2NavItem key={l.href} href={l.href} label={l.label} childLinks={l.children} exactMatch={l.exactMatch} />
            ))}
          </ul>
        </nav>
      </ConstrainedFullWidth>
    </>
  )
}
export default Tier2NavBar
